import type { Appointment } from '@/api/appointments/appointmentsApi.types';

export function filterAppointmentsForIsoDate(
  appointments: Appointment[],
  isoDate: string
): Appointment[] {
  return appointments.filter(function matchesIsoDate(appointment) {
    return appointment.date === isoDate;
  });
}

export function sortAppointmentsByStartTime(appointments: Appointment[]): Appointment[] {
  const appointmentsCopy = [...appointments];
  return appointmentsCopy.sort(function compareByStartTime(firstAppointment, secondAppointment) {
    return firstAppointment.startTime.localeCompare(secondAppointment.startTime);
  });
}
